import request from "../utils/request-v1";

// Example: Get Countries
export function getAllCountry() {
  return request({
    url: "/countries",
    method: "get",
  });
}
